if(window.innerWidth > 575) {
  const addresses = document.querySelectorAll('.addresses');
  let count = 3;

  if (window.innerWidth < 992) {
    count = 2;
  }

  Height('.addresses__address');
  Height('.addresses__subtitle');

  function Height(selector) {
    addresses.forEach(addr => {
      const items = addr.querySelectorAll(selector);
      const rows = Math.ceil((items.length / 3));

      for (let i = 0; i < rows; i++) {
        let height = 0;

        let elems = [];

        for (let j = 0; j < count; j++) {
          if (items[count * i + j]) {
            elems[j] = items[count * i + j].offsetHeight;
          }
        }

        height = Math.max(...elems);

        for (let j = 0; j < count; j++) {
          if (items[count * i + j]) {
            items[count * i + j].style.height = height + 'px';
          }
        }
      }
    });
  }
}
